import React from "react";
import {Select, InputNumber} from "antd";
import styles from './Menu.module.css';
import btnStyles from '../Buttons/EditorBtn/EditorBtnCss.module.css';
import EditorBtn from "../Buttons/EditorBtn/EditorBtn";

const {Option} = Select;

export default class Menu extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            size: null,
            defaultFonts: [],
            fontStyles: [],
            alignHorizontalStyle: [],
            alignVerticalStyle: [],
            activeFont: null,
        };
        this.inputNumber = React.createRef();
    }

    componentDidMount() {
        this.initConfig();
        this.undoRedoListener();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.graph !== this.props.graph) {
            this.undoRedoListener();
        }
    }


    undoRedoListener = () => {
        const {graph} = this.props;
        graph.manager.addListener(window.mxEvent.UNDO, this.listener);
        graph.manager.addListener(window.mxEvent.REDO, this.listener);
    };

    componentWillUnmount() {
        const {graph} = this.props;
        graph.manager.removeListener(this.listener);
    }

    listener = () => {
        this.initConfig();
    };


    initConfig() {
        const fontStyles = [
            {
                cssClass: `${btnStyles.geSprite_bold}`,
                title: 'Bold',
                textStyle: window.mxConstants.FONT_BOLD,
                active: false
            }, {
                cssClass: `${btnStyles.geSprite_italic}`,
                title: 'Italic',
                textStyle: window.mxConstants.FONT_ITALIC,
                active: false
            }, {
                cssClass: `${btnStyles.geSprite_underline}`,
                title: 'Underline',
                textStyle: window.mxConstants.FONT_UNDERLINE,
                active: false
            }];

        const alignHorizontalStyle = [
            {
                cssClass: `${btnStyles.geSprite_left}`,
                title: 'Left',
                textStyle: window.mxConstants.ALIGN_LEFT,
                active: false
            }, {
                cssClass: `${btnStyles.geSprite_center}`,
                title: 'Center',
                textStyle: window.mxConstants.ALIGN_CENTER,
                active: false
            }, {
                cssClass: `${btnStyles.geSprite_right}`,
                title: 'Right',
                textStyle: window.mxConstants.ALIGN_RIGHT,
                active: false
            }];

        const alignVerticalStyle = [
            {
                cssClass: `${btnStyles.geSprite_top}`,
                title: 'Top',
                textStyle: window.mxConstants.ALIGN_TOP,
                active: false

            }, {
                cssClass: `${btnStyles.geSprite_middle}`,
                title: 'Middle',
                textStyle: window.mxConstants.ALIGN_MIDDLE,
                active: false
            }, {
                cssClass: `${btnStyles.geSprite_bottom}`,
                title: 'Bottom',
                textStyle: window.mxConstants.ALIGN_BOTTOM,
                active: false
            }];

        const defaultFonts = [`${window.mxConstants.DEFAULT_FONTFAMILY}`,
            'Helvetica', 'Verdana', 'Times New Roman', 'Garamond', 'Comic Sans MS',
            'Courier New', 'Georgia', 'Lucida Console', 'Tahoma'];

        this.setActiveFontStyles(fontStyles);
        this.setActiveAlignHorizontalStyle(alignHorizontalStyle);
        this.setActiveAlignVerticalStyle(alignVerticalStyle);
        this.setState({
            defaultFonts,
            fontStyles,
            alignHorizontalStyle,
            alignVerticalStyle,
            size: this.getActiveSize(),
            activeFont: this.getActiveFontFamily()
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.cynyText !== prevProps.cynyText) {
            this.inputNumber.current.blur();
            this.initConfig();
        }
    }

    getActiveFontFamily = () => {
        const {graph, cynyText} = this.props;
        const style = graph.getCurrentCellStyle(cynyText);
        return style.fontFamily || window.mxConstants.DEFAULT_FONTFAMILY;
    };

    getActiveSize = () => {
        const {graph, cynyText} = this.props;
        const style = graph.getCurrentCellStyle(cynyText);
        return style.fontSize || window.mxConstants.DEFAULT_FONTSIZE
    };

    setActiveFontStyles(fontStyles) {
        const {graph, cynyText} = this.props;
        const style = graph.getCurrentCellStyle(cynyText);

        if (style.fontStyle) {
            const total = style.fontStyle;
            switch (total) {
                case 1:
                    fontStyles[0].active = true;
                    break;
                case 2:
                    fontStyles[1].active = true;
                    break;
                case 4:
                    fontStyles[2].active = true;
                    break;
                case 3:
                    fontStyles[0].active = true;
                    fontStyles[1].active = true;
                    break;
                case 5:
                    fontStyles[0].active = true;
                    fontStyles[2].active = true;
                    break;
                case 6:
                    fontStyles[1].active = true;
                    fontStyles[2].active = true;
                    break;
                case 7:
                    fontStyles[0].active = true;
                    fontStyles[1].active = true;
                    fontStyles[2].active = true;
                    break;
            }
        }
    }

    setActiveAlignHorizontalStyle(alignHorizontalStyle) {
        this.setActiveAlignStyle(alignHorizontalStyle, 'align');
    }

    setActiveAlignVerticalStyle(alignVerticalStyle) {
        this.setActiveAlignStyle(alignVerticalStyle, 'verticalAlign');
    }

    setActiveAlignStyle(array, key) {
        const {graph, cynyText} = this.props;
        const style = graph.getCurrentCellStyle(cynyText);
        array.forEach(s => {
            if (s.textStyle === style[key]) {
                s.active = true
            }
        });
    }


    onFontChange = (font) => {
        const {graph, cynyText} = this.props;
        this.setState({activeFont: font});
        graph.setCellStyles(window.mxConstants.STYLE_FONTFAMILY, font, [cynyText]);
    };


    toggleFontStyle = (btnConfig) => {
        const {graph, cynyText} = this.props;
        const {fontStyles} = this.state;
        const fontStyleValue = graph.getCurrentCellStyle(cynyText).fontStyle;
        if (fontStyleValue !== undefined) {
            if (btnConfig.active) {
                graph.setCellStyles(window.mxConstants.STYLE_FONTSTYLE, fontStyleValue - btnConfig.textStyle, [cynyText]);
            } else {
                graph.setCellStyles(window.mxConstants.STYLE_FONTSTYLE, fontStyleValue + btnConfig.textStyle, [cynyText]);
            }
        } else graph.setCellStyles(window.mxConstants.STYLE_FONTSTYLE, btnConfig.textStyle, [cynyText]);
        btnConfig.active = !btnConfig.active;
        this.setState({fontStyles: [...fontStyles]});
    };

    handleFontSizeChange = (value) => {
        const {graph} = this.props;
        const cells = graph.getSelectionCells();
        this.setState({size: value});
        graph.setCellStyles(window.mxConstants.STYLE_FONTSIZE, value, cells);

    };

    createSelect = () => {
        const {defaultFonts, activeFont} = this.state;
        return (
            <div className={styles.block_fontSelect}>
                <Select value={activeFont}
                        style={{width: 100 + '%'}}
                        title="Font Family"
                        onChange={this.onFontChange}>
                    {defaultFonts.map((font) => {
                        return (<Option key={font} value={font}>{font}</Option>)
                    })}
                </Select>
            </div>
        )
    };

    handleAlignStyleText = (btnConfig, array, typeStyle, nameArray) => {
        const {graph, cynyText} = this.props;
        const align = graph.getCurrentCellStyle(cynyText)[typeStyle];
        if (!btnConfig.active) {
            graph.setCellStyles(typeStyle, btnConfig.textStyle, [cynyText]);
            btnConfig.active = true;
            const element = array.find(style => style.textStyle === align);
            element.active = false
        }
        this.setState({[nameArray]: [...array]})
    };

    handleAlignHorizontalStyleText = (btnConfig) => {
        const {alignHorizontalStyle} = this.state;
        this.handleAlignStyleText(btnConfig, alignHorizontalStyle, window.mxConstants.STYLE_ALIGN, 'alignHorizontalStyle');
    };

    handleAlignVerticalStyleText = (btnConfig) => {
        const {alignVerticalStyle} = this.state;
        this.handleAlignStyleText(btnConfig, alignVerticalStyle, window.mxConstants.STYLE_VERTICAL_ALIGN, 'alignVerticalStyle');
    };

    render() {
        const {fontStyles, alignHorizontalStyle, alignVerticalStyle, size} = this.state;
        return (
            <div className={styles.toolbarContainer}>
                <div className={`${styles.flex} ${styles.toolbarContainer_block}`}>
                    {this.createSelect()}
                    <InputNumber ref={this.inputNumber} className={`${styles.block_controlSize}`}
                                 min={1}
                                 max={999}
                                 value={size}
                                 title="Font Size"
                                 onChange={this.handleFontSizeChange}/>
                </div>
                <div className={`${styles.flex} ${styles.toolbarContainer_block}`}>
                    <div
                        className={styles.btn_block}>{alignHorizontalStyle.map((btnConfig, index) => {
                        return <EditorBtn key={index} config={btnConfig}
                                          handleClick={() => {
                                              this.handleAlignHorizontalStyleText(btnConfig);
                                          }}/>
                    })}</div>
                    <div
                        className={styles.btn_block}>{fontStyles.map((btnConfig, index) => {
                        return <EditorBtn key={index} config={btnConfig}
                                          handleClick={() => {
                                              this.toggleFontStyle(btnConfig);
                                          }}/>
                    })}</div>
                    <div
                        className={styles.btn_block}>{alignVerticalStyle.map((btnConfig, index) => {
                        return <EditorBtn key={index} config={btnConfig}
                                          handleClick={() => {
                                              this.handleAlignVerticalStyleText(btnConfig);
                                          }}/>
                    })}</div>
                </div>
            </div>
        )
    }
}
